import * as errorActions from './actions';
import errors from './reducer';

export { errors, errorActions };
export default errorActions;
